import { Factory, trait } from 'miragejs';
import { faker } from '@faker-js/faker';

faker.seed(1);

const balanceGenerator = {
	balance: {
		amount: () => parseFloat(faker.finance.amount()),
		currency: { id: 'EUR' },
	},
};

const type = {
	id: () => faker.helpers.arrayElement(['RZ', 'RB', 'TRPE', 'TR', 'TF', 'RQ', 'TP', 'XO']),
	name: faker.lorem.words(2),
};

const fundFields = {
	reason: () => 'Suscripción',
	effectiveValue: {
		amount: () => parseFloat(faker.finance.amount()),
		currency: { id: 'EUR' },
	},
	isin: () => faker.finance.bic(),
	name: () => faker.company.name(),
	liquidationValue: {
		amount: () => parseFloat(faker.finance.amount()),
		currency: { id: 'EUR' },
	},
	unityQuantity: () =>
		faker.number.int({
			min: 1,
			max: 100000,
		}),
};

const inversisFundFields = {
	type: () => ({ name: 'Suscripción' }),
	amount: {
		amount: () => parseFloat(faker.finance.amount()),
		currency: { id: 'EUR' },
	},
	isin: () => ({
		id: faker.finance.bic(),
		name: faker.company.name(),
	}),
	titles: () =>
		faker.number.int({
			min: 1,
			max: 100000,
		}),
};

export default Factory.extend({
	'reason': () => faker.lorem.words(4),
	'amount': {
		amount: () => parseFloat(faker.finance.amount()) * -1,
		currency: { id: 'EUR' },
	},
	'valueDate': () => faker.date.past(0.4, '2022-00-00'),
	'operationDate': () => faker.date.past(0.3, '2022-00-00'),
	'expirationDate': () => faker.date.past(0.3, '2022-00-00'),
	'avoidable': () => faker.datatype.boolean(),
	'movementCoreId': () => faker.finance.bic(),
	'comment': {
		commentId: () => faker.finance.bic(),
		comment: () => faker.lorem.words(20),
	},
	'checking-account': trait({
		...balanceGenerator,
		type,
	}),
	'account': trait({
		...balanceGenerator,
		type,
	}),
	'currency-account': trait({
		...balanceGenerator,
		type,
	}),
	'junior-account': trait({
		...balanceGenerator,
		type,
	}),
	'support-account': trait({
		...balanceGenerator,
		type,
	}),
	'hefame-account': trait({
		...balanceGenerator,
		type,
	}),
	'managed-account': trait({
		...balanceGenerator,
		type,
	}),
	'managed-currency-account': trait({
		...balanceGenerator,
		type,
	}),
	'debit-card': trait({ paymentMethod: () => 'Debit' }),
	'credit-card': trait({
		deferPayment: () => faker.datatype.boolean(),
		paymentMethod: () => 'Credit',
	}),
	'viat-card': trait({
		paymentMethod: () => 'Viat',
	}),
	'business-debit-card': trait({}),
	'business-credit-card': trait({}),
	'term-deposit': trait({
		...balanceGenerator,
		amount: {
			amount: () => parseFloat(faker.finance.amount()),
			currency: { id: 'EUR' },
		},
		state: {
			id: '01',
			name: 'Viva',
		},
	}),
	'deposit': trait({
		...balanceGenerator,
		amount: {
			amount: () => parseFloat(faker.finance.amount()),
			currency: { id: 'EUR' },
		},
		state: {
			id: '01',
			name: 'Viva',
		},
	}),
	'demand-deposit': trait({
		...balanceGenerator,
		amount: {
			amount: () => parseFloat(faker.finance.amount()),
			currency: { id: 'EUR' },
		},
		state: {
			id: '01',
			name: 'Viva',
		},
	}),
	'currency-deposit': trait({}),
	'advised-fund': trait(fundFields),
	'commercialized-fund': trait(fundFields),
	'delegated-fund': trait(fundFields),
	'pension-plan': trait({
		unityQuantity: faker.number.int({
			min: 1,
			max: 100000,
		}),
		unityValue: {
			amount: () => parseFloat(faker.finance.amount(1, 10000, 9)),
			currency: { id: 'EUR' },
		},
	}),
	'shares': trait({}),
	'securities-account': trait({
		reason: () => faker.finance.transactionType(),
		unityQuantity: () =>
			faker.number.int({
				min: 1,
				max: 100000,
			}),
		isin: () => faker.finance.bic(),
		name: () => faker.company.name(),
		price: {
			amount: () => parseFloat(faker.finance.amount()),
			currency: { id: 'EUR' },
		},
		liquidAmount: {
			amount: () => parseFloat(faker.finance.amount()),
			currency: { id: 'EUR' },
		},
		commissionsRetentions: {
			amount: () => parseFloat(faker.finance.amount()),
			currency: { id: 'EUR' },
		},
	}),
	'loan-var': trait({
		type: () => faker.lorem.words(4),
	}),
	'loan-fixed': trait({
		type: () => faker.lorem.words(4),
	}),
	'loan-mix': trait({
		type: () => faker.lorem.words(4),
	}),
	'tpv': trait({}),
	'guarantee-policy-fixed': trait(balanceGenerator),
	'guarantee-policy-var': trait(balanceGenerator),
	'discount-line': trait({}),
	'subscription': trait({}),
	'pending-movements': trait({
		originFund: {
			id: () => faker.finance.bic(),
			name: () => faker.finance.bic(),
		},
	}),
	'investment-account-rto': trait(inversisFundFields),
	'investment-pension-plan': trait(inversisFundFields),
	'bizum': trait({
		valueDate: () => faker.date.recent(2),
		sender: {
			name: () => faker.person.fullName(),
			phone: () => faker.phone.number(),
			account: () => faker.finance.iban(),
		},
		beneficiary: {
			name: () => faker.person.fullName(),
			phone: () => faker.phone.number(),
		},
		amount: {
			amount: () => parseFloat(faker.finance.amount()),
			currency: { id: 'EUR' },
		},
		reason: () => faker.lorem.words(4),
		status: () =>
			faker.helpers.arrayElement([
				{ id: '01', name: 'PENDING' },
				{ id: '02', name: 'ACCEPTED' },
				{ id: '03', name: 'REJECTED' },
				{ id: '04', name: 'RETURN' },
				{ id: '05', name: 'CANCELLED' },
				{ id: '06', name: 'ERROR' },
				{ id: '07', name: 'DENIED' },
				{ id: '08', name: 'EXPIRED' },
			]),
		type: () =>
			faker.helpers.arrayElement([
				{ id: '01', name: 'SENT' },
				{ id: '02', name: 'RECEIVED' },
				{ id: '03', name: 'REQUEST-SENT' },
				{ id: '04', name: 'REQUEST-RECEIVED' },
				{ id: '05', name: 'SENT-SELAE' },
				{ id: '06', name: 'SENT-COM' },
				{ id: '07', name: 'SENT-ECOM' },
				{ id: '08', name: 'RECEIVED-SELAE' },
			]),
		hasExtraInfo: false,
		possibleActions: ['ACCEPT', 'DENY', 'RETURN', 'CANCEL'],
	}),
	'bizum-selae': trait({
		valueDate: () => new Date(),
		operationDate: () => new Date(),
		status: () => ({ id: '02', name: 'ACCEPTED' }),
		possibleActions: () => [],
	}),
});
